/**
 * Created by arun on 6/6/18.
 */
export class BankAccountModel {
  object?: string;
  id?: string;
  requested_by_user_id?: string;
  requested_by_user_name?: string;
  created_by_user_id?: string;
  created_by_user_name?: string;
  requested_at?: string;
  account_holder_first_name?: string;
  account_holder_last_name?: string;
  account_holder_type?: string;
  bank_name?: string;
  bank_phone_number?: string;
  used_for?: boolean;
  status?: string;
  history_status?: string;
  note?: string;
  upload_link?: string;
  reason?: string;
  routing_number?: string;
  old_routing_number?: string;
  bank_account_number?: string;
  old_bank_account_number?: string;
  last4?: string;
  currency?: string;
  account_type?: string;
  transaction_type?: string;
  created_at?: string;
  updated_at?: string;
}

